import lrList from './_src/lrList.vue'

lrList.install = function(Vue) {
  Vue.component(lrList.name, lrList)
}

export default lrList